// 后端 avatarColorRgb → 135° 渐变背景（基色 + 提亮 40 的次色）
// 兼容 'r,g,b' / 'rgb(r,g,b)' / 'rgba(r,g,b,a)' / '#RRGGBB' / '#RGB' / [r,g,b]
// 解析不出来返回 ''（调用方自行兜底，比如名字 hash 渐变）
export function parseRgb(v) {
  if (v == null || v === '') return null
  if (Array.isArray(v)) {
    return v.length >= 3 ? { r: +v[0] || 0, g: +v[1] || 0, b: +v[2] || 0 } : null
  }
  const s = String(v).trim()
  // #RRGGBB
  let m = s.match(/^#?([0-9a-f]{6})$/i)
  if (m) { const n = parseInt(m[1], 16); return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 } }
  // #RGB
  m = s.match(/^#?([0-9a-f]{3})$/i)
  if (m) { const h = m[1]; return { r: parseInt(h[0] + h[0], 16), g: parseInt(h[1] + h[1], 16), b: parseInt(h[2] + h[2], 16) } }
  // 'r,g,b' / 'rgb(r,g,b)' / 'rgba(r,g,b,a)'
  // 注意：先 filter 掉空字符串再 Number，否则 Number('')===0 会把前导空 token 当成 0 挤进结果
  const nums = s.replace(/[^\d.,\s]/g, ' ').split(/[,\s]+/).filter(t => t !== '').map(Number).filter(x => !isNaN(x))
  if (nums.length >= 3) return { r: nums[0], g: nums[1], b: nums[2] }
  return null
}

// 后端 avatarColorRgb → 纯色背景（无头像图时用）。解析不出来返回 ''（不前端兜底生成色）。
export function solidFromColor(raw) {
  const c = parseRgb(raw)
  if (!c) return ''
  return `rgb(${c.r},${c.g},${c.b})`
}

// 兼容旧调用：仍按纯色返回（不再生成渐变）
export function gradientFromColor(raw) {
  return solidFromColor(raw)
}
